import type { ComponentChildren } from "preact";
import { cn } from "./cn";

export function EmptyState({
  icon,
  title,
  description,
  cta,
  class: extraClass,
}: {
  icon?: ComponentChildren;
  title: string;
  description?: ComponentChildren;
  cta?: ComponentChildren;
  class?: string;
}) {
  return (
    <div
      class={cn(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-border bg-bg-subtle/40 px-6 py-12 text-center",
        extraClass,
      )}
    >
      {icon && (
        <div class="inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-bg text-fg-subtle">
          {icon}
        </div>
      )}
      <div class="space-y-1">
        <div class="text-sm font-semibold text-fg">{title}</div>
        {description && (
          <div class="text-sm text-fg-subtle">{description}</div>
        )}
      </div>
      {cta && <div class="pt-1">{cta}</div>}
    </div>
  );
}
